import { gsap, DrawSVGPlugin } from "@/utilities/gsap.js"
import { getAll } from "@/utilities/querySelector.js"

const counterElems = getAll('[data-counter]');

if (counterElems.length) {
    counterElems.forEach(elem => {
        const text = elem.textContent;
        const numberMatch = text.match(/\d+/); // Extract just the numbers
        const number = numberMatch ? Number(numberMatch[0]) : 0;
        const prefix = text.split(/[0-9]/)[0] || '';
        const suffix = text.split(/[0-9]/).slice(-1)[0] || '';
        let hasAnimated = false;

        const tl = gsap.timeline({
            paused: true,
            onComplete: () => {
                hasAnimated = true;
            }
        });

        const proxy = { value: 0 };
        tl.to(proxy, {
            value: number,
            duration: 2,
            ease: "power1.inOut",
            onUpdate: function() {
                elem.textContent = prefix + Math.round(proxy.value) + suffix;
            }
        });

        const checkViewState = () => {
            if (elem.getAttribute('data-in-view') === 'true' && !hasAnimated) {
                tl.play();
            }
        };

        checkViewState();

        const observer = new MutationObserver(checkViewState);
        observer.observe(elem, {
            attributes: true,
            attributeFilter: ['data-in-view']
        });
    });
}
